import { rootApi } from '../../services/rootApi';
import { dashboardApi } from '../../utils/urls';
import CourseStore from '../../../../legacy/src/js/stores/Course';

export const dashboardApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: ({ sortBy, sortMode, filters }) => ({
        url: dashboardApi(),
        method: 'POST',
        body: {
          data: {
            sortBy,
            sortMode,
            filters,
            pageLength: 50,
            pageStart: 0
          },
          method: 'read'
        }
      }),
      transformResponse: (response) => {
        // legacy update
        const legacyGlobalData = CourseStore.getInitialState();
        legacyGlobalData.courses = response.data;
        legacyGlobalData.course = {};
        legacyGlobalData.page = {};
        CourseStore.triggerForLegacy(legacyGlobalData);

        return response.data;
      },
      providesTags: ['Dashboard']
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDashboardQuery,
} = dashboardApiSlice;
